var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusDeclined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29688 0.292969C4.68741 -0.0973676 5.32048 -0.0974929 5.71094 0.292969C6.10121 0.683446 6.10121 1.31655 5.71094 1.70703L4.41602 3.00195L5.71094 4.29688C6.10109 4.68743 6.10134 5.32054 5.71094 5.71094C5.32054 6.10134 4.68743 6.10109 4.29688 5.71094L3.00195 4.41602L1.70703 5.71094C1.31655 6.10121 0.683446 6.10121 0.292969 5.71094C-0.0974929 5.32048 -0.0973676 4.68741 0.292969 4.29688L1.58789 3.00195L0.292969 1.70703C-0.0975555 1.31651 -0.0975555 0.683493 0.292969 0.292969C0.683493 -0.0975555 1.31651 -0.0975555 1.70703 0.292969L3.00195 1.58789L4.29688 0.292969Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDeclined);
export default __webpack_public_path__ + "static/media/status-declined.255aa71104b5775159de52ae7f176603.svg";
export { ForwardRef as ReactComponent };